const PAGE_SIZE = 5;
export function handleUserClickNextPageAction(state) {
  const {
    currentPage,
    lastPage,
    allRows
  } = state;
  if (currentPage >= lastPage) {
    return [state, null];
  }
  const nextPageStart = currentPage * PAGE_SIZE;
  const displayedRows = allRows.slice(nextPageStart, nextPageStart + PAGE_SIZE);
  return [{
    ...state,
    displayedRows,
    currentPage: currentPage + 1
  }, null];
}
export function handleUserClickPrevPageAction(state) {
  const {
    currentPage,
    allRows
  } = state;
  if (currentPage <= 1) {
    return [state, null];
  }
  const prevPage = currentPage - 1;
  const previousPageStart = (prevPage - 1) * PAGE_SIZE;
  const displayedRows = allRows.slice(previousPageStart, previousPageStart + PAGE_SIZE);
  return [{
    ...state,
    displayedRows,
    currentPage: prevPage
  }, null];
}
export function getInitialPaginatedState(state, allRows) {
  const {
    currentPage
  } = state;
  const lastPage = Math.ceil(allRows.length / PAGE_SIZE);
  const currentPageStart = (currentPage - 1) * PAGE_SIZE;
  const displayedRows = allRows.slice(currentPageStart, currentPageStart + PAGE_SIZE);
  const showPagination = lastPage > 1;
  return {
    ...state,
    displayedRows,
    allRows,
    lastPage,
    showPagination
  };
}